
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/item_inventory",
      function () {
        return require("private-next-pages/item_inventory.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/item_inventory"])
      });
    }
  